import webClient from "../config/api.config";

// MED-1622: the account PIN routes of medecine360-bff (camelCase bodies).

export function requestCreatePin(pin: string) {
  return webClient.request({
    method: "post",
    url: "/account/pin",
    data: { pin },
  });
}

export function requestUnlockPin(pin: string) {
  return webClient.request({
    method: "post",
    url: "/account/pin/unlock",
    data: { pin },
  });
}

export function requestChangePin(currentPin: string, newPin: string) {
  return webClient.request({
    method: "put",
    url: "/account/pin",
    data: { currentPin, newPin },
  });
}

export function requestPinReset() {
  return webClient.request({
    method: "post",
    url: "/account/pin/reset/request",
  });
}

export function requestConfirmPinReset(otp: string, newPin: string) {
  return webClient.request({
    method: "post",
    url: "/account/pin/reset/confirm",
    data: { otp, newPin },
  });
}

/** MED-1644: sets the idle delay before the PIN lock, in minutes. */
export function requestUpdatePinLockDelay(lockMinutes: number) {
  return webClient.request({
    method: "put",
    url: "/account/pin/lock_delay",
    data: { lockMinutes },
  });
}

/** Tells the server the user is active, so it does not lock the session. */
export function requestActivityPing() {
  return webClient.request({
    method: "post",
    url: "/account/activity",
    // Background call: an offline user must not get an error modal a minute.
    silent: true,
  });
}
